
@if (hasChanged) {
  <p class="not-saved-block">Изменения не сохранены</p>
}
@if (isLoading) {
  <div><app-preloader></app-preloader></div>
}

@if (!isLoading) {
  <div>
    @if (ItemData) {
      <div class="content-wrapper">
        @if (!(ItemData|iframeValidator)){
          <p style="color: red">Неверный формат</p>
        } @else {
          <app-iframe-wrapper [html]="ItemData"></app-iframe-wrapper>
        }
      </div>
    }
    @if (!ItemData) {
      <p class="no-file">Нет ресурса</p>
    }
    @if (IsSelected) {
      <div class="input-wrap" (click)="$event.stopPropagation()">
        <label class="f-title">Iframe</label>
        <textarea class="form-input"
          [(ngModel)]="ItemData"
          placeholder="<iframe src=...>"></textarea>
          <div class="buttons">
            <div class="button" (click)="changeText()">Сохранить текст</div>
            <div class="button" (click)="cancelChangeText()">Вернуть назад</div>
          </div>
        </div>
      }
    </div>
  }
  @if (showIframe){
    <app-iframe-modal
      [visible]="showIframe"
      [content]="ItemData"
      (closed)="closeIframe()">
    </app-iframe-modal>
  }

